export default "__VITE_ASSET__d5a91701__"